<template>
  <tr
    class="row"
    :class="{ 'highlight': hasHotel }"
  >
    <td>
      {{ lowRange.range }}
      <div class="card-holder">
        <div
          v-for="(hotelId, index) in lowRange.hotels"
          :key="index"
        >
          <stock-card
            :hotel-id="hotelId"
            compact
          />
        </div>
      </div>
    </td>
    <td>
      {{ midRange.range }}
      <div class="card-holder">
        <div
          v-for="(hotelId, index) in midRange.hotels"
          :key="index"
        >
          <stock-card
            :hotel-id="hotelId"
            compact
          />
        </div>
      </div>
    </td>
    <td>
      {{ highRange.range }}
      <div class="card-holder">
        <div
          v-for="(hotelId, index) in highRange.hotels"
          :key="index"
        >
          <stock-card
            :hotel-id="hotelId"
            compact
          />
        </div>
      </div>
    </td>
    <td class="border-left">
      {{ price | formatCurrency }}
    </td>
    <td class="border-left">
      {{ firstBonus | formatCurrency }}
    </td>
    <td>
      {{ secondBonus | formatCurrency }}
    </td>
  </tr>
</template>

<script>
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import { formatCurrency } from "@/currency-filter";
import {getPriceAndBonus, HOTEL_SIZE_RANGES} from "@/store/utils";
import {
  HOTEL_AMERICAN,
  HOTEL_CONTINENTAL,
  HOTEL_FESTIVAL,
  HOTEL_IMPERIAL,
  HOTEL_LUXOR,
  HOTEL_TOWER,
  HOTEL_WORLDWIDE,
} from "@/store/game/constants";
import {NS_GAME_STATE} from "@/store/constants";
import {HIGH_HOTEL_PRICES, LOW_HOTEL_PRICES, MID_HOTEL_PRICES} from "@/store/game/constants";
import StockCard from "@/components/StockCard";

// const HOTEL_VALUES = {
//   low: [HOTEL_TOWER, HOTEL_LUXOR],
//   mid: [HOTEL_WORLDWIDE, HOTEL_FESTIVAL, HOTEL_AMERICAN],
//   high: [HOTEL_IMPERIAL, HOTEL_CONTINENTAL],
// };

export default {
  name: 'BonusReferenceCardRow',
  components: {StockCard},
  props: {
    row: {
      type: Number,
      required: true,
    },

    hotelCounts: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      HOTEL_AMERICAN,
      HOTEL_CONTINENTAL,
      HOTEL_FESTIVAL,
      HOTEL_IMPERIAL,
      HOTEL_LUXOR,
      HOTEL_TOWER,
      HOTEL_WORLDWIDE,
      numberOfRows: 11,
    }
  },

  filters:{
    formatCurrency,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'stocks',
      'tilesPerHotel',
    ]),

    price() {
      return this.lowRange.price || this.highRange.price;
    },

    firstBonus() {
      return this.lowRange.firstBonus || this.highRange.firstBonus;
    },

    secondBonus() {
      return this.lowRange.secondBonus || this.highRange.secondBonus;
    },

    hasHotel() {
      return get(this, 'lowRange.hotels.length', false)
        || get(this, 'midRange.hotels.length', false)
        || get(this, 'highRange.hotels.length', false);
    },

    lowRange() {
      const hotelSize = HOTEL_SIZE_RANGES[this.row];
      if (!hotelSize) {
        return {
          range: '-'
        }
      }

      return {
        hotels: this.getHotelIds(hotelSize.low, hotelSize.high, [HOTEL_TOWER, HOTEL_LUXOR]),
        range: this.formatRange(hotelSize.low, hotelSize.high),
        ...getPriceAndBonus(LOW_HOTEL_PRICES, hotelSize.low)
      };
    },

    midRange() {
      if (this.row === 0) {
        return {
          range: '-',
        };
      }

      const hotelSize = HOTEL_SIZE_RANGES[this.row - 1];
      if (!hotelSize) {
        return {
          range: '-'
        }
      }

      return {
        hotels: this.getHotelIds(hotelSize.low, hotelSize.high, [HOTEL_AMERICAN, HOTEL_FESTIVAL, HOTEL_WORLDWIDE]),
        range: this.formatRange(hotelSize.low, hotelSize.high),
        ...getPriceAndBonus(MID_HOTEL_PRICES, hotelSize.low)
      };
    },

    highRange() {
      if (this.row === 0 || this.row === 1) {
        return {
          range: '-',
        };
      }

      const hotelSize = HOTEL_SIZE_RANGES[this.row - 2];
      return {
        hotels: this.getHotelIds(hotelSize.low, hotelSize.high, [HOTEL_CONTINENTAL, HOTEL_IMPERIAL]),
        range: this.formatRange(hotelSize.low, hotelSize.high),
        ...getPriceAndBonus(HIGH_HOTEL_PRICES, hotelSize.low)
      };
    }
  },

  methods: {
    formatRange(low, high) {
      if(low === high) {
        return low;
      }

      if (!high) {
        return `${low}+`;
      }

      return `${low} - ${high}`;
    },

    getHotelIds(low, high, possibleHotelIds) {
      const hotels = this.hotelCounts.filter(hotel => {
        if (!possibleHotelIds.includes(hotel.hotelId)) {
          return false;
        }

        if (hotel.count >= low && hotel.count <= high){
          return true;
        }

        return false;
      });

      return hotels.map(hotel => {
        return hotel.hotelId;
      })
    }
  }
}
</script>

<style scoped>
.card-holder {
  display: flex;
  justify-content: center;
  padding-top: 3px;
}

.row {
  text-align: center;
  color: grey;
  border-bottom: 1px solid #00000014;
}

.row td {
  padding: 5px;
  /*border: 1px solid #00000014;*/
}

.highlight {
  color: black;
  background: #e0f3f58c;
  box-shadow: 2px 4px 4px #0000001a;
}

.border-left {
  border-left: 1px solid #00000014;
}
</style>
